import sycamoreServiceClient from '.';

export const fetchInvestment = async offer_link => {
  const response = await sycamoreServiceClient({
    url: `/customer/premium/investment/contract/${offer_link}`,
    method: 'get',
  }, "___target");

  return {
    status: response.status,
    data: response.data,
  };
};

export const decidePremiumInvestmentContract = async body => {
    const response = await sycamoreServiceClient({
      url: '/customer/premium/investment/contract/decide',
      method: 'post',
      data: body,
    }, "___target");
  
    return {
      status: response.status,
      data: response.data,
    };
  };
